enum QuizTypes {
  Scoring = 'scoring',
  Personality = 'personality',
  Prediction = 'prediction',
  Poll = 'poll',
  Survey = 'survey',
  RankingPoll = 'rankingPoll',
  TeamSelector = 'teamSelector'
};

export default QuizTypes;
